import { SVGProps } from "react";

const TrashCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={30} cy={30} r={30} fill="#FFF6F4" />
    <g clipPath="url(#clip0_8935_123909)">
      <path
        d="M20 23.75H40"
        stroke="#E43820"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 28.75V36.25"
        stroke="#E43820"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5 28.75V36.25"
        stroke="#E43820"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.25 23.75L22.5 38.75C22.5 39.413 22.7634 40.0489 23.2322 40.5178C23.7011 40.9866 24.337 41.25 25 41.25H35C35.663 41.25 36.2989 40.9866 36.7678 40.5178C37.2366 40.0489 37.5 39.413 37.5 38.75L38.75 23.75"
        stroke="#E43820"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 23.75V20C26.25 19.6685 26.3817 19.3505 26.6161 19.1161C26.8505 18.8817 27.1685 18.75 27.5 18.75H32.5C32.8315 18.75 33.1495 18.8817 33.3839 19.1161C33.6183 19.3505 33.75 19.6685 33.75 20V23.75"
        stroke="#E43820"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8935_123909">
        <rect
          width={30}
          height={30}
          fill="white"
          transform="translate(15 15)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default TrashCircle;
